module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/error-2fbdd051600acdfac6f096b4a40d0f8d.png";